{#if icon === 'Ccpa'}
  <CcpaSvg />
{/if}

<script>
  import CcpaSvg from './icons/Ccpa.html'
  export let icon;
</script>